import { BrowserRouter, Routes, Route } from "react-router-dom";
import GtaxPage from "@/pages/GtaxPage";
import DeskPage from "@/pages/DeskPage";
import { GtaxErrorBoundary } from "@/components/gtax/GtaxErrorBoundary";

export default function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/desk/*" element={<DeskPage />} />
                <Route path="/news" element={<DeskPage />} />
                <Route path="/*" element={<GtaxErrorBoundary><GtaxPage /></GtaxErrorBoundary>} />
            </Routes>
        </BrowserRouter>
    );
}
